<template lang="pug">
  .listTab03
    transition(name="fade", mode="out-in")
      rankTabs(:taskList="taskList", :defaultTaskId="defaultTaskId")
    .loading.extraText(v-if="isLoading") 资料读取中！！！！！
    .loaded(v-else)
      transition(name="fade", mode="out-in")
        .dailySelectInner
          .dailySelect(v-if="availableDates.length > 0")
            div 请选择日期：
            div.dateSelect
              select.selectStyle(v-model="selectedDate")
                option(v-for="(day, idx) in availableDates", :key="idx", :value="day.cycle") {{day.range}}
          .dailySelect(v-else) 暂无资料
          .dailyResearch 若查询的日期资料未显示，请过30分钟后再次查询。
      transition(name="fade", mode="out-in")
        .tabContent
          ul.tabItemList
            v-touch(tag="li", v-for="board in filteredList", :class="{active: board.id === currentTab}", @tap="changeTab(board.id)", :key="board.id")
              button {{board.name}}
          .itemlist-wrap(v-if="filteredList.length > 0")
            transition(name="fade", mode="out-in")
              .itemTab01(v-for="(board, index) in filteredList", v-if="board.id === currentTab", :key="board.id")
                transition(name="fade", mode="out-in")
                  div(v-if="board.rank_list.length > 0")
                    .rankIcon
                      .iconItem(:class="currentRankTab.suffix[index]")
                    header {{dateRange}} {{board.name}}结果
                    rankTable(:list="board.rank_list", :preferLength="board.rank_list.length < board.len ? board.len : board.rank_list.length")
                  p.nullInfo(v-else) 暂无资料
</template>

<script>
import rankTable from './rankTable'
import rankTabs from './rankTabs'
import {compact} from 'lodash'

export default {
  props: ['taskList'],
  components: {
    rankTable,
    rankTabs
  },
  created () {
    this.$bus.$on('rankTabOnChange', this.rankTabOnChange)
    this.rankTabOnChange(this.defaultTaskId)
  },
  watch: {
    availableDates: function (newValue, oldValue) {
      this.rankTabOnChange(this.currentRankTab.value)
    }
  },
  data () {
    return {
      defaultTaskId: this.taskList[0].taskId,
      currentRankTab: null,
      campaign: null,
      leaderboardHistory: null,
      selectedDate: '',
      currentTab: '',
      dateRangeList: []
    }
  },
  methods: {
    changeTab (val) {
      this.currentTab = val
    },
    rankTabOnChange (taskId) {
      this.taskList.forEach(task => {
        if (task.taskId === taskId) {
          this.campaign = task
          this.leaderboardHistory = task.historyLeaderBoard
          this.selectedDate = (this.filteredList[0] || {}).cycle || (this.availableDates[0] || {}).cycle
          this.currentTab = (this.filteredList[0] || {}).id || ''

          this.dateRangeList = Array.from(this.availableDates) // deep clone array
          this.dateRangeList.reverse()

          this.currentRankTab = task.rankTab
        }
      })
    }
  },
  computed: {
    availableDates () {
      let availableDates = []
      for (let cycle in this.leaderboardHistory) {
        let hasRank = this.leaderboardHistory[cycle].map(board => {
          return board.rank_list.length > 0
        })
        if (compact(hasRank).length > 0) {
          availableDates.push({cycle: cycle, range: this.campaign.dayIdList[cycle]})
        }
      }
      return availableDates.reverse()
    },
    filteredList () {
      return this.leaderboardHistory[this.selectedDate] || []
    },
    dateRange () {
      return (this.dateRangeList.filter(val => val.cycle === this.selectedDate)[0] || {}).range
    },
    isLoading () {
      return this.campaign.fetchCycles.length !== 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';

.nullInfo {
  width: 100%;
  text-align: center;
  color: $black;
  margin: 0;
  @include rem(font-size, 1.8rem);
  @include breakpoint($iSE_p){
    @include rem(font-size, 1.6rem);
  }
  @include breakpoint(1024px){
    @include rem(font-size, 2.4rem);
  }
}

.listTab03 {
  padding: 0px 10px;
  box-sizing: border-box;
  @include breakpoint(1024px) {
    padding: 0px;
  }
  .dailySelectInner {
    padding: .5rem 1.5rem;
    margin: 0 0 1rem;
    border-radius: 15px;
    background-color: $ligten-blue;
    @include breakpoint(1024px) {
      padding: .5rem 0;
    }
  }
  .dailySelect {
    display: flex;
    color: $black;
    font-weight: bold;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 1em;
    margin-bottom: 25px;
    @include rem(font-size, 1.8rem);
    @include breakpoint($iSE_p){
      @include rem(font-size, 1.6rem);
    }
    @include breakpoint(1024px){
      @include rem(font-size, 2.4rem);
    }
    div {
      margin: 0 10px;
    }
    .dateSelect {
      background: url('../assets/images/arrow.svg') no-repeat right center;
      background-size: 20px 20px;
    }
    .selectStyle {
      width: 100%;
      position:relative;
      background: transparent;
      border: 0;
      color: $black;
      outline: none;
      font-weight: bold;
      cursor: pointer;
      -moz-appearance:none; /* Firefox */
      -webkit-appearance:none; /* Safari and Chrome */
      appearance:none;
      padding: 0 1.3em;
      option {
        color: $black;
      }
    }
  }
  .dailyResearch {
    display: flex;
    color: $black;
    justify-content: center;
    align-items: center;
    margin-bottom: 25px;
    @include rem(font-size, 1.5rem);
    @include breakpoint(1024px){
      @include rem(font-size, 2rem);
    }
  }
  .itemlist-wrap {
    padding: 10px 15px 15px;
    overflow: hidden;
    box-sizing: border-box;
    header {
      text-align: center;
      font-weight: bold;
      margin-bottom: 25px;
      @include rem(font-size, 1.7rem);
      @include breakpoint(1024px) {
        @include rem(font-size, 2.4rem);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/historyLeaderBoard.vue